module.exports = __webpack_public_path__ + "images/88818f30ce667ad806b110d7ca7c4720.svg";